import * as $ from 'jquery';
// import * as Push from 'push.js';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { AuthPageComponent } from './page/auth-page/auth-page.component';
import { AppRoutingModule } from './app-routing.module';
import { RingLoadingEffectComponent } from './page_component_item/ring-loading-effect/ring-loading-effect.component';
import { PasswordResetComponent } from './components/menu-profile/components/password-reset/password-reset.component';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';
import { SearchToolComponent } from './page/search-tool/search-tool.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { DataTablesModule } from 'angular-datatables';
import { ExcelService } from './services/excel/excel.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { CmdbInfoPageComponent } from './page/cmdb/cmdb-info-page/cmdb-info-page.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { JsonPipe } from '@angular/common';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ChartModule } from 'primeng/chart';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { CmdbRegisterPageComponent } from './page/cmdb/cmdb-register-page/cmdb-register-page.component';
import { CmdbDashboardComponent } from './page/cmdb/cmdb-dashboard/cmdb-dashboard.component';
import { KnowledgeBasePageReworkComponent } from './page/knowledge-base/knowledge-base-page-rework/knowledge-base-page-rework.component';
import { BlankPageTemplateComponent } from './page/blank-page-template/blank-page-template.component';
import { KnowledgeArchivePageComponent } from './page/knowledge-base/knowledge-archive-page/knowledge-archive-page.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RegisterPageComponent } from './page/register-page/register-page.component';
import { RequestCategorizationComponent } from './page/register/request/categorization/request-categorization.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { StylesheetComponent } from './page/register-page/register-forms/customer/stylesheet/stylesheet.component';
import { LocalityComponent } from './page/register-page/register-forms/customer/locality/locality.component';
import { DepartmentComponent } from './page/register-page/register-forms/customer/department/department.component';
import { ClassificationComponent } from './page/register-page/register-forms/classification/classification/classification/classification.component';
import { ReportSpreadsheetComponent } from './page_component/report-spreadsheet/report-spreadsheet.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { CmdbAlertComponent } from './page/register-page/register-forms/cmdb/notification/cmdb-alert.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import * as echarts from 'echarts';
import { CmdbSearchFilterComponent } from './page_component/cmdb-search-filter/cmdb-search-filter.component';
import { CmdbExportPageComponent } from './page/report/cmdb-export-page/cmdb-export-page.component';
import { CockpitPageComponent } from './page/cockpit/cockpit-page/cockpit-page.component';
import { FilterHeaderComponent } from './page/cockpit/cockpit-page/components/filter-header/filter-header.component';
import { NgChartsModule } from 'ng2-charts';
import { CockpitEditComponent } from './page/cockpit/cockpit-edit/cockpit-edit.component';
import { ReplacePipe } from './util/pipes/replace.pipe';
import { ErrorPageComponent } from './page/error-page/error-page.component';
import { SearchFilterComponent } from './page_component/search-filter/search-filter.component';
import { RequestClassificationComponent } from './page_component/request-classification/request-classification.component';
import { CmdbStockReportPageComponent } from './page/report/cmdb-stock-report-page/cmdb-stock-report-page.component';
import { StockPageComponent } from './page/stock/stock-page/stock-page.component';
import { SiteComponent } from './page/register-page/register-forms/customer/site/site.component';
import { VisualFormatPipe } from './util/pipes/visual-format.pipe';
import { CmdbReportPageComponent } from './page/report/cmdb-report-page/cmdb-report-page.component';
import { MultiSplicePipe } from './util/pipes/multi-splice.pipe';
import { QRCodeModule } from 'angularx-qrcode';
import { CmdbQrcodeComponent } from './page/cmdb/cmdb-qrcode/cmdb-qrcode.component';
import { ImportExcelComponent } from './page_component/import-excel/import-excel.component';
import { CmdbLoadComponent } from './page/register-page/register-forms/cmdb/cmdb-load/cmdb-load.component';
import { CmdbPrintQrcodeComponent } from './page/cmdb/cmdb-print-qrcode/cmdb-print-qrcode.component';
import { ManufacturerComponent } from './page/register-page/register-forms/cmdb/manufacturer/manufacturer.component';
import { ModelComponent } from './page/register-page/register-forms/cmdb/model/model.component';
import { OperationalSystemComponent } from './page/register-page/register-forms/cmdb/operational-system/operational-system.component';
import { CpuModelComponent } from './page/register-page/register-forms/cmdb/cpu-model/cpu-model.component';
import { MspMultiCheckboxSelectComponent } from './page_component_item/msp-multi-checkbox-select/msp-multi-checkbox-select.component';
import { mspGlobal } from './util/global/mspGlobal';
import { CiFieldComponent } from './page/register-page/register-forms/cmdb/ci-field/ci-field.component';
import { GeneralLabelComponent } from './page/register-page/register-forms/general/general-label/general-label.component';
import { InfoAlertModule } from './page_component_item/info-alert/info-alert.module';
import { ActiveDirectoryComponent } from './page/register-page/register-forms/integration/active-directory/active-directory.component';
import { AccessSettingsComponent } from './page/register-page/register-forms/integration/access-settings/access-settings/access-settings.component';
import { GroupsUsersComponent } from './page/register-page/register-forms/general/groups-users/groups-users.component';
import { GeneralEndusersComponent } from './page/register-page/register-forms/general/general-endusers/general-endusers/general-endusers.component';
import { UsersComponent } from './page/register-page/register-forms/general/users/users.component';
import { RequestTaskComponent } from './page_component/request-task/request-task.component';
import { CustomColumnsExcelComponent } from './page_component/custom-columns-excel/custom-columns-excel.component';
import { CustomLabelsComponent } from './page/register-page/register-forms/customer/custom_labels/custom-labels.component';
import { ReportHubComponent } from './page/report/report-hub/report-hub.component';
import { ReportFormComponent } from './page/report/report-form/report-form.component';
import { VersionPageComponent } from './page/version/version-page.component';
import { ToolSsoComponent } from './page/register-page/register-forms/tools/tool-sso/tool-sso.component';
import { CustomPresetColumnsReportComponent } from './page/register-page/register-forms/customer/custom-preset-columns-report/custom-preset-columns-report.component';
import { RequestFieldFiltersComponent } from './page/register-page/register-forms/request/request-field-filters/request-field-filters.component';
import { CustomerStrikeComponent } from './page/register-page/register-forms/request/customer-strike/customer-strike.component';
import { CustomEmailsComponent } from './page/register-page/register-forms/customer/custom-emails/custom-emails.component';
import { ServiceCatalogComponent } from './page/register-page/register-forms/request/service-catalog/service-catalog/service-catalog.component';
import { RequestOpeningTemplateComponent } from './page/register-page/register-forms/request/request-opening-template/request-opening-template.component';
import { CustomAccordionComponent } from './components/menu-profile/components/custom-accordion/custom-accordion.component';
import { CustomStatusComponent } from './page/register-page/register-forms/request/custom-status/custom-status.component';
import { CustomerInformationComponent } from './page/register-page/register-forms/customer/customer-information/customer-information.component';
import { StockInfoPageComponent } from './page/stock/stock-info-page/stock-info-page.component';
import { TaskExpirationComponent } from './page/register-page/register-forms/request/task-expiration/task-expiration.component';
import { SubstatusComponent } from './page/register-page/register-forms/cmdb/substatus/substatus.component';
import { KnowledgeManagementTagsComponent } from './page_component/knowledge-management-tags/knowledge-management-tags.component';
import { RequestClassificationReverseComponent } from './page_component/request-classification-reverse/request-classification-reverse.component';
import { CustomSatisfactionRequestComponent } from './page/register-page/register-forms/request/custom-satisfaction-request/custom-satisfaction-request.component';
import { ApproversGroupComponent } from './page/register-page/register-forms/customer/approvers-group/approvers-group.component';
import { ImpactMatrixComponent } from './page/register-page/register-forms/request/impact-matrix/impact-matrix.component';
import { StockCountComponent } from './page_component/stock-count/stock-count.component';
import { RegisterRequestCustomfieldComponent } from './page/register-page/register-forms/request/request-customfield/request-customfield.component';
import { RegisterRequestCustomfieldOrderComponent } from './page/register-page/register-forms/request/request-customfield-order/request-customfield-order.component';
import { AdminPasswordResetComponent } from './page/register-page/register-forms/admin/admin-password-reset/admin-password-reset.component';
import { SlaManagementComponent } from './page/register-page/register-forms/request/sla-management/sla-management.component';
import { TaskManagementComponent } from './page/register-page/register-forms/request/task-management/task-management.component';
import { TaskCustomFieldComponent } from './page/register-page/register-forms/request/task-custom-field/task-custom-field.component';
import { ImpactXurgencyXseverityComponent } from './page/register-page/register-forms/customer/impact-xurgency-xseverity/impact-xurgency-xseverity.component';
import { DefaultUrgencyComponent } from './page/register-page/register-forms/customer/impact-xurgency-xseverity/default-urgency/default-urgency.component';
import { DefaultImpactComponent } from './page/register-page/register-forms/customer/impact-xurgency-xseverity/default-impact/default-impact.component';
import { CmdbDigitalTermComponent } from './page/cmdb/cmdb-digital-term/cmdb-digital-term.component';
import { NotificationPageComponent } from './page/notification-page/notification-page.component';
import { NotificationManagementComponent } from './page/register-page/register-forms/notification/notification-management/notification-management.component';
import { ContextMenuComponent } from './page_component_item/context-menu/context-menu.component';
import { ChecklistHomePageComponent } from './page/checklist/checklist-home-page/checklist-home-page.component';
import { ChecklistRegisterPageComponent } from './page/checklist/checklist-register-page/checklist-register-page.component';
import { GenericFormGenModule } from './page_component_item/generic-form-gen/generic-form-gen.module';
import { CheckboxModule } from './page_component_item/checkbox/checkbox.module';
import { DotBounceLoadingEffectModule } from './page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { InputWithAutocompleteModule } from './page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { ModalComponent } from './page_component_item/modal/modal.component';
import { SvgGearsModule } from './page_component_item/svg-gears/svg-gears.module';
import { MspPipesModule } from './util/pipes/msp-pipes.module';
import { ToggleSwitchModule } from './page_component_item/toggle-switch/toggle-switch.module';
import { MyAssetConfigurationGeneralComponent } from './page/my-asset/configuration-general/configuration-general.component';
import { ThreeStateToggleSwitchModule } from './page_component_item/three-state-toggle-switch/three-state-toggle-switch.module';
import { CmdbSearchGadgetComponent } from './page_component/cmdb-search-gadget/cmdb-search-gadget.component';
import { GroupManagerAnalystsComponent } from './page/register-page/register-forms/request/group-manager-analysts/group-manager-analysts.component';
import { PaginationCounterModule } from './page_component_item/pagination-counter/pagination-counter.module';
import { TableGenericFiltersModule } from './page/my-asset/inconsistencies/components/table-generic-filters/table-generic-filters.module';
import { MspTableModule } from './page_component_item/msp-table/msp-table.module';
import { MspTableRmkComponent } from './page_component_item/msp-table-rmk/msp-table-rmk.component';
import { SquarePostLoadingEffectModule } from './page_component_item/square-post-loading-effect/square-post-loading-effect.module';
import { BreadcrumbNavigationComponent } from './page_component_item/breadcrumb-navigation/breadcrumb-navigation.component';
import { MenuProfileComponent } from './components/menu-profile/menu-profile.component';
import { MspSelectComponent } from './page_component_item/form/msp-select/msp-select.component';
import { FileUploadModule } from './page_component_item/file-upload/file-upload.module';
import { TooltipModule } from './util/directives/tooltip/tooltip.module';
import { MenuLateralModule } from './components/menu-lateral/menu-lateral.module';
import { MspButtonComponent } from './page_component_item/msp-button/msp-button.component';
import { JsonDynamicFieldModule } from './page_component/json-dynamic-field/json-dynamic-field.module';
import { RequestOpeningModule } from './page_component/request-opening/request-opening.module';
import { MysupportEvaluationModule } from './page_component/mysupport-evaluation/mysupport-evaluation.module';
import { RequestCustomfieldModule } from './page_component/request-customfield/request-customfield.module';
import { RequestClassificationReverseRmkModule } from './page_component/request-classification-reverse-rmk/request-classification-reverse-rmk.module';
import { DateRangePickerModule } from './page_component_item/date-range-picker/date-range-picker.module';
import { CmdbRegisterPageInconsistenciesModule } from './page/cmdb/cmdb-register-page/components/cmdb-register-page-inconsistencies/cmdb-register-page-inconsistencies.module';
import { StatusCiTypeModule } from './page/register-page/register-forms/cmdb/status-ci-type/status-ci-type.module';
import { CmdbRegisterPageAttachmentModule } from './page/cmdb/cmdb-register-page/components/cmdb-register-page-attachment/cmdb-register-page-attachment.module';
import { CmdbRegisterPageLogsModule } from './page/cmdb/cmdb-register-page/components/cmdb-register-page-logs/cmdb-register-page-logs.module';
import { CmdbRegisterPageBondModule } from './page/cmdb/cmdb-register-page/components/cmdb-register-page-bond/cmdb-register-page-bond.module';
import { CmdbRegisterPageInfoModule } from './page/cmdb/cmdb-register-page/components/cmdb-register-page-info/cmdb-register-page-info.module';
import { RingLoadingEffectModule } from './page_component_item/ring-loading-effect/ring-loading-effect.module';
import { MspSemantixLogoModule } from './page_component_item/msp-semantix-logo/msp-semantix-logo.module';
import { RequestPageModule } from './page/request/request-page/request-page.module';
import { ConfirmButtonModule } from './util/directives/confirmButton/confirm-button.module';
import { CollapseDirective } from './util/directives/collapse/collapse.directive';
import { CockpitChartModule } from './page/cockpit/cockpit-page/components/cockpit-chart/cockpit-chart.module';
@NgModule({
	declarations: [
		AppComponent,
		AuthPageComponent,
		ForgotPasswordComponent,
		SearchToolComponent,
		CmdbInfoPageComponent,
		CmdbRegisterPageComponent,
		KnowledgeBasePageReworkComponent,
		BlankPageTemplateComponent,
		KnowledgeArchivePageComponent,
		RegisterPageComponent,
		StylesheetComponent,
		LocalityComponent,
		DepartmentComponent,
		SiteComponent,
		ClassificationComponent,
		ReportSpreadsheetComponent,
		CmdbSearchFilterComponent,
		CmdbExportPageComponent,
		CmdbAlertComponent,
		CockpitPageComponent,
		FilterHeaderComponent,
		CockpitEditComponent,
		ReplacePipe,
		ErrorPageComponent,
		RequestClassificationComponent,
		CmdbStockReportPageComponent,
		StockPageComponent,
		VisualFormatPipe,
		CmdbReportPageComponent,
		MultiSplicePipe,
		CmdbQrcodeComponent,
		ImportExcelComponent,
		CmdbLoadComponent,
		CmdbPrintQrcodeComponent,
		VersionPageComponent,
		ManufacturerComponent,
		ModelComponent,
		CiFieldComponent,
		GeneralLabelComponent,
		ActiveDirectoryComponent,
		AccessSettingsComponent,
		GroupsUsersComponent,
		GeneralEndusersComponent,
		UsersComponent,
		RequestTaskComponent,
		CustomLabelsComponent,
		CustomColumnsExcelComponent,
		ReportHubComponent,
		ReportFormComponent,
		ToolSsoComponent,
		CustomPresetColumnsReportComponent,
		RequestFieldFiltersComponent,
		CustomerStrikeComponent,
		CustomEmailsComponent,
		ServiceCatalogComponent,
		RequestOpeningTemplateComponent,
		CustomStatusComponent,
		CustomerInformationComponent,
		StockInfoPageComponent,
		TaskExpirationComponent,
		SubstatusComponent,
		KnowledgeManagementTagsComponent,
		RequestClassificationReverseComponent,
		CustomSatisfactionRequestComponent,
		ApproversGroupComponent,
		StockCountComponent,
		ImpactMatrixComponent,
		RegisterRequestCustomfieldComponent,
		RegisterRequestCustomfieldOrderComponent,
		AdminPasswordResetComponent,
		SlaManagementComponent,
		TaskManagementComponent,
		TaskCustomFieldComponent,
		DefaultUrgencyComponent,
		DefaultImpactComponent,
		ImpactXurgencyXseverityComponent,
		ContextMenuComponent,
		CmdbDigitalTermComponent,
		NotificationManagementComponent,
		NotificationPageComponent,
		ContextMenuComponent,
		GroupManagerAnalystsComponent,
	],
	imports: [
		BrowserModule,
		RequestCategorizationComponent,
		DragDropModule,
		MatMenuModule,
		MatIconModule,
		DataTablesModule,
		MatPaginatorModule,
		JsonPipe,
		MatSlideToggleModule,
		MatInputModule,
		MatFormFieldModule,
		HttpClientModule,
		ReactiveFormsModule,
		CommonModule,
		FormsModule,
		FontAwesomeModule,
		AppRoutingModule,
		NgxEchartsModule.forRoot({ echarts }),
		BrowserAnimationsModule,
		MatCardModule,
		OrganizationChartModule,
		ChartModule,
		AngularEditorModule,
		MatTooltipModule,
		ColorPickerModule,
		NgChartsModule,
		NgxMaskModule.forRoot(),
		QRCodeModule,
		ChecklistHomePageComponent,
		ChecklistRegisterPageComponent,
		OperationalSystemComponent,
		CpuModelComponent,
		GenericFormGenModule,
		CheckboxModule,
		DotBounceLoadingEffectModule,
		InputWithAutocompleteModule,
		SvgGearsModule,
		ModalComponent,
		MspPipesModule,
		ToggleSwitchModule,
		ThreeStateToggleSwitchModule,
		MyAssetConfigurationGeneralComponent,
		CmdbSearchGadgetComponent,
		PaginationCounterModule,
		TableGenericFiltersModule,
		MspTableModule,
		MspTableRmkComponent,
		SquarePostLoadingEffectModule,
		BreadcrumbNavigationComponent,
		MenuProfileComponent,
		CustomAccordionComponent,
		SearchFilterComponent,
		PasswordResetComponent,
		MspSelectComponent,
		FileUploadModule,
		TooltipModule,
		JsonDynamicFieldModule,
		MenuLateralModule,
		MspButtonComponent,
		RequestOpeningModule,
		MysupportEvaluationModule,
		RequestCustomfieldModule,
		RequestClassificationReverseRmkModule,
		DateRangePickerModule,
		InfoAlertModule,
		CmdbRegisterPageInconsistenciesModule,
		CmdbRegisterPageAttachmentModule,
		CmdbRegisterPageBondModule,
		CmdbRegisterPageInfoModule,
		CmdbRegisterPageLogsModule,
		MspMultiCheckboxSelectComponent,
		StatusCiTypeModule,
		RingLoadingEffectModule,
		MspSemantixLogoModule,
		RequestPageModule,
		ConfirmButtonModule,
		CollapseDirective,
		CockpitChartModule,
	],
	providers: [ExcelService, mspGlobal],
	bootstrap: [AppComponent],
})
export class AppModule {}
